<template>
  <validation-observer ref="observer" v-slot="{ passes }">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ titulo }}
        </p>
      </header>
      <div class="modal-card-body">
        <section>
          <validation-provider v-slot="{ errors, valid }" rules="required">
            <b-field
              label="Nombre Zona"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-input v-model="model.nombre" type="text" />
            </b-field>
          </validation-provider>
          <div class="columns">
            <div class="column">
              <validation-provider
                v-slot="{ errors, valid }"
                rules="required|numeric"
              >
                <b-field
                  label="Meta Tiempo Promedio"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                >
                  <b-input v-model.number="model.metaPromedio" type="text" />
                </b-field>
              </validation-provider>
            </div>
            <div class="column">
              <validation-provider
                v-slot="{ errors, valid }"
                rules="required|numeric"
              >
                <b-field
                  label="Meta Tiempo Tope OV"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                >
                  <b-input v-model.number="model.metaTiempoTope" type="text" />
                </b-field>
              </validation-provider>
            </div>
          </div>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.esZonaPrincipal" type="is-info">
                ¿Es zona principal?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.esZonaPicking" type="is-info">
                ¿Es zona picking?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.esZonaDespacho" type="is-info">
                ¿Es zona despacho?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.esZonaRapida" type="is-info">
                ¿Es zona picking r&aacute;pido?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.puedePausar" type="is-info">
                ¿Puede pausar pedidos?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.asignaOtraZona" type="is-info">
                ¿Permite asignar en zona principal?
              </b-checkbox>
            </b-field>
          </validation-provider>
          <validation-provider v-slot="{ errors, valid }">
            <b-field
              :custom-class="'checkbox-input'"
              :type="{ 'is-danger': errors[0], 'is-success': valid }"
              :message="errors"
            >
              <b-checkbox v-model="model.estaActiva" type="is-info">
                ¿Est&aacute; activa?
              </b-checkbox>
            </b-field>
          </validation-provider>
        </section>
      </div>
      <footer class="modal-card-foot">
        <div class="buttons">
          <b-button type="is-info" @click="passes(submit)">
            <span>Guardar</span>
          </b-button>
          <button class="button" @click="cerrarForm">
            <span>Salir</span>
          </button>
        </div>
      </footer>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { numeric, required } from 'vee-validate/dist/rules'

import { zonaService } from '@/services'

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})

extend('numeric', {
  ...numeric,
  message: 'Este campo debe ser un valor númerico positivo',
  validate(value) {
    return value >= 0
  }
})

export default {
  name: 'ZonaForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    titulo: {
      type: String,
      default: 'Agregar Registro'
    },
    modificacion: {
      type: Boolean,
      default: false
    },
    bodega: {
      type: Number,
      default: 0
    },
    objeto: {
      type: Object,
      required: false,
      default: () => this.modeloInicial
    }
  },
  data() {
    return {
      model: this.modeloInicial(),
      cargando: false
    }
  },
  computed: {
    postModel() {
      return Object.assign(this.model, { bodegaId: this.bodega })
    },
    esZonaPrincipal() {
      return this.model.esZonaPrincipal
    },
    esZonaPicking() {
      return this.model.esZonaPicking
    },
    esZonaDespacho() {
      return this.model.esZonaDespacho
    },
    esZonaRapida() {
      return this.model.esZonaRapida
    }
  },
  watch: {
    esZonaPrincipal(newVal) {
      if (newVal) {
        this.model.esZonaPicking = true
        this.model.esZonaDespacho = false
        this.model.esZonaRapida = false
      }
    },
    esZonaPicking(newVal) {
      if (!newVal) {
        this.model.esZonaPrincipal = false
        this.model.esZonaPicking = false
        this.model.esZonaRapida = false
      }
    },
    esZonaDespacho(newVal) {
      if (newVal) {
        this.model.esZonaPicking = false
        this.model.esZonaPrincipal = false
      }
    },
    esZonaRapida(newVal) {
      if (newVal) {
        this.model.esZonaPicking = true
        this.model.esZonaDespacho = false
        this.model.esZonaPrincipal = false
      }
    }
  },
  mounted() {
    this.model = Object.assign(this.model, this.objeto)
  },
  methods: {
    submit() {
      const self = this
      Promise.all([
        this.modificacion
          ? zonaService.updateZona(self.objeto.id, self.postModel)
          : zonaService.addZona(self.postModel)
      ])
        .then((rs) => {
          self.notificarAccionCompletada(
            `Se ${this.modificacion ? 'modificó' : 'agregó'} zona correctamente`
          )
          self.$emit('close', true)
        })
        .catch((error) => self.procesarError(error))
    },
    cerrarForm() {
      this.$emit('close', false)
    },
    resetForm() {
      this.model = this.modeloInicial
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    modeloInicial() {
      return {
        id: null,
        nombre: null,
        esZonaPrincipal: false,
        esZonaPicking: false,
        esZonaDespacho: false,
        esZonaRapida: false,
        puedePausar: false,
        estaActiva: true,
        asignaOtraZona: false,
        metaPromedio: 0,
        metaTiempoTope: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-input {
  margin-top: 20px;
}
</style>
